var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 40,
    viewBox: "0 0 200 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1656",
    "data-name": "Rectangle 1656",
    width: 196.987,
    height: 35.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-K_logo_white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "K_logo_white",
    "data-name": "K logo white",
    clipPath: "url(#clip-K_logo_white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3626",
    "data-name": "Group 3626",
    transform: "translate(1 1.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M24.514,16.675H16.869L29.645.9H40.916L30.423,13.857a7.6,7.6,0,0,1-5.909,2.818",
    transform: "translate(-8.498 -0.456)",
    fill: "#23cb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M14.629,18H4.127A4.126,4.126,0,0,0,0,22.13V35.254H8.248V20.177L23.3,35.254H34.7L19.488,20.01A6.559,6.559,0,0,0,14.629,18M53.94.137l-18.172,35.1,1.205,0A.816.816,0,0,0,37.7,34.8l5.094-9.881,15.8.025,5.011,9.9a.817.817,0,0,0,.727.447l8.5.013L54.705.138a.6.6,0,0,0-.765,0M43.569,23.429,50.741,9.582l7.084,13.869ZM4.123,16.22H8.248V.507H0V12.1A4.123,4.123,0,0,0,4.123,16.22M117.96,17.484c2.105-1.477,3.174-3.811,3.179-6.935a7.854,7.854,0,0,0-2.827-6.543,14.094,14.094,0,0,0-6.469-2.788A49.008,49.008,0,0,0,103.822.6L89.465.561V1.638h-.009v17.25h4.121A4.126,4.126,0,0,0,97.7,14.761V2.078l6.117.009c3.075,0,5.367.671,6.818,1.982,1.434,1.3,2.158,3.472,2.154,6.466,0,2.893-.792,5.03-2.34,6.353a9.974,9.974,0,0,1-6.658,2.019,1.269,1.269,0,0,0-.993,2.062l11.268,14.085a.817.817,0,0,0,.636.306l9.062.014L111.029,20.033a16.145,16.145,0,0,0,6.931-2.549M194.8,19.541a14.808,14.808,0,0,0-5.118-3.162c-1.923-.723-4.487-1.518-7.619-2.361-2.648-.732-4.756-1.371-6.266-1.9a11.313,11.313,0,0,1-3.657-2.023,3.621,3.621,0,0,1-1.366-2.875,4.406,4.406,0,0,1,2.715-4.036,16.159,16.159,0,0,1,7.557-1.528,25.437,25.437,0,0,1,2.922.19c.154.023.295.041.46.068A8.922,8.922,0,0,1,189.642,4.2a6.263,6.263,0,0,1,1.917,4.315h3.28a6.451,6.451,0,0,0-1.857-4.423,11.843,11.843,0,0,0-5.113-2.948A25.449,25.449,0,0,0,180.28.128a25.788,25.788,0,0,0-8.264,1.238,13.5,13.5,0,0,0-5.8,3.582,7.955,7.955,0,0,0-2.14,5.464,6.727,6.727,0,0,0,2.091,5.033,14.677,14.677,0,0,0,4.909,3.063c1.874.73,4.386,1.54,7.468,2.41,2.73.769,4.894,1.456,6.432,2.039a12.447,12.447,0,0,1,3.818,2.216,3.957,3.957,0,0,1,1.449,3.12c0,2.05-1.058,3.5-3.233,4.452a19.639,19.639,0,0,1-7.851,1.5A31.255,31.255,0,0,1,175.137,34l-.044-.007c-.589-.077-1.1-.232-1.65-.345a8.513,8.513,0,0,1-3.618-1.764,6.638,6.638,0,0,1-2.032-4.152h-3.211l0,.006h-1.161a6.837,6.837,0,0,0,2.029,3.847,13.446,13.446,0,0,0,5.774,3.132,29.538,29.538,0,0,0,8.24,1.061A30.26,30.26,0,0,0,188.2,34.59a14.651,14.651,0,0,0,6.358-3.645,8.423,8.423,0,0,0,2.433-6.082,7.1,7.1,0,0,0-2.192-5.322M152.215,2.285a24.022,24.022,0,0,0-19.174-.031,16.835,16.835,0,0,0-7.124,6A17.146,17.146,0,0,0,123.2,18a17.149,17.149,0,0,0,2.681,9.756,16.813,16.813,0,0,0,7.105,6.02,24.018,24.018,0,0,0,19.174.031,16.813,16.813,0,0,0,7.124-6A17.143,17.143,0,0,0,162,18.063a17.148,17.148,0,0,0-2.681-9.756,16.833,16.833,0,0,0-7.105-6.022M142.6,34.3c-7.246-.012-10.762-5.339-10.744-16.285s3.55-16.262,10.8-16.25c7.212.011,10.71,5.338,10.693,16.285S149.815,34.312,142.6,34.3m-67.732,1,8.247.013L83.173.568,74.926.555ZM93.58,20.671H89.455V35.3H97.7v-10.5a4.123,4.123,0,0,0-4.123-4.123",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlogowhite);
export default __webpack_public_path__ + "static/media/Klogowhite.b5ce3e7bc3366e94148ef7b879e8f970.svg";
export { ForwardRef as ReactComponent };